// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAkCSatNXzZO6sz9RnxFuOs-ZBMiuIbFtc",

  authDomain: "krushisetu-digital.firebaseapp.com",

  projectId: "krushisetu-digital",

  storageBucket: "krushisetu-digital.firebasestorage.app",

  messagingSenderId: "1068348951790",

  appId: "1:1068348951790:web:3b465477f98e1a4cf7b7ff",

  measurementId: "G-P3HZDVLSSX",
};
const app = initializeApp(firebaseConfig);
firebase.initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Google Auth Provider
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
export default firebase;
